
import { Component, Vue } from 'vue-property-decorator'

import BacHeader from '@/templates/BacHeader.vue'

import { Http } from '@/lib/utils/Http'

import UIkit from 'uikit'
import { Auth } from '@/middlewares/Auth'

@Component({
  components: {
    BacHeader
  }
})
export default class Login extends Vue {
    username = '';
    password = '';
    rememberMe = true;
    destinationPage = '/your-rallies';
    cookieOptions: {expires?: string; domain?: string} = {}

    async mounted () {
      window.location.href = '/app'
      if (this.$route.query.logout === '1') {
        this.logout()
        return
      }
      if (process.env.NODE_ENV !== 'development') {
        this.cookieOptions.domain = 'https://www.backroadclub.com'
      }
      if (Auth.isTokenValid()) {
        this.$router.push('/your-rallies')
      } else {
        if (await Auth.refreshToken()) {
          this.$router.push('/your-rallies')
        }
      }
    }

    async logout () {
      window.localStorage.removeItem('accessToken')
      window.localStorage.removeItem('refreshToken');
      (this as any).$cookie.delete('accessToken');
      (this as any).$cookie.delete('refreshToken')
    }

    async login (e: Event) {
      e.preventDefault()

      let message = ''

      if (!this.password) {
        message = 'Geben Sie ein Passwort an!'
      }
      if (!this.username) {
        message = 'Geben Sie eine E-Mail Adresse an!'
      }

      if (message) {
        UIkit.notification({
          message: message,
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        return
      }

      const res = await Http.request('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
          rememberMe: this.rememberMe
        })
      })

      if (res.status !== 200) {
        UIkit.notification({
          message: 'Irgendetwas stimmt hier nicht. <br>Prüfe deine Eingabe oder <br><a href="/teamarea/forget">setze dein Passwort neu</a>',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })

        return
      }

      const loginData = await res.json()

      // set auth cookie

      if (this.rememberMe) {
        this.cookieOptions.expires = '3Y'
      }

      console.log('setting cookie:', loginData, this.cookieOptions)
      window.localStorage.setItem('accessToken', loginData.accessToken)
      window.localStorage.setItem('refreshToken', loginData.refreshToken)

      this.$router.push(this.destinationPage)
    }
}
